import { EventBus } from 'vtils'

export const instantDeliveryBus = new EventBus<{
  refreshCart: () => any
}>()
